import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  addContactButtonFields,
  addContactModalFields,
  addCustomerModalFields,
  addCustomerContactNotesFields,
  errorMessage,
  fieldNames,
  getJobLeadsFields,
  successMessage,
  addContactFormValidation,
  addContactFieldNames,
  addCustomerFormValidation,
  addCustomerFieldNames,
  accountTermsOptions,
  customerAddMessages,
  customStylingSelectField,
  customerModalFields,
  contactModalFields,
  contactAddMessages,
  CUSTOM_INPUT,
  COMPANY_EXISTS_ERROR,
  addRoleValidation,
  contactEditMessages,
  UploadModalConst,
} from "./constants";
import ConditionalRender from "../../../../reusable-components/ConditionalRender/index";
import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";
import InputField from "../../../../reusable-components/TNInputField/index";
import RadioComponent from "../../../../reusable-components/RadioComponent/index";
import styles from "./JobLead.module.scss";
import Label from "../../../../reusable-components/Label/index";
import { Button, Modal, Popover, Select, Tooltip, message } from "antd";
import TNButton from "../../../../reusable-components/TNButton/index";
import {
  ButtonShape,
  ButtonType,
  ButtonSize,
  CommonButtonTexts,
} from "../../../../enums/ButtonAttributesEnums";
import CreateJobServices from "../../../../services/createJob.services";
import {
  getDropdownOptions,
  getContactDropdownOptions,
  getSalesPersonDropdownOptions,
  toLabelValueArray,
  getDropdownOptionsCustomLabel,
  getJobDropdownOptions,
} from "../../../../utils/getDropdownOptions";
import TNGoogleAddressSuggestions from "../../../../reusable-components/TNGoogleSearch/index";
import ProjectInformationSheetProofUpload from "./ProjectInformationSheetProofUpload/index";
import { set, useFormContext } from "react-hook-form";
import Loading from "../../../../Common/Loading";
import { useLocation } from "react-router-dom";
import Form from "../../../Form";
import { v4 as uuidv4 } from "uuid";
import editEllips from "../../../../assets/images/ellipsisListing.svg";
import editIcon from "../../../../assets/images/edit-document-icon.svg";
import contactEditIcon from "../../../../assets/images/editEntry.svg";
import deleteIcon from "../../../../assets/images/delete-contact-icon.svg";
import { PopoverTrigger } from "../../../../enums/PopoverEnums";
import { PlacementPositions } from "../../../../enums/PlacementPositionsEnums";
import { formatPhoneNumber } from "../../../../utils/numberFormatterUtil";
import CustomerDatabaseService from "../../../../services/customerDatabase.service";
import clsx from "clsx";
import { FileTypes } from "../../../../enums/FileUploadEnums";
import AddRoleModal from "./AddRoleModal";
import { DocTypes } from "../../../../enums/DocTypes";
import { createJobCommonConstants } from "../constants";
import { showConfirmModal } from "../../../../utils/popupModalUtils";
import { TaxExemptCertificateState } from "../../../../enums/TaxExemptCertificateState";
import { ProjectInformationSheetState } from "../../../../enums/ProjectInformationSheetState";

const JobLead = ({
  uploadedFiles,
  fileUploadHandler,
  handleProjectFileUpload,
  handleTaxFileUpload,
  jobDetails,
  leadId,
  handleEnableResetOrders,
  selectedImportJobId,
  handleSelectedImportJobId,
}) => {
  const location = useLocation();
  const editable = location.pathname?.includes(
    "/app/update-trucking-material/",
  );
  const { setValue, watch, resetField, clearErrors } = useFormContext();
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isReceived, setIsReceived] = useState("");
  const [isExempt, setIsExempt] = useState("");
  const [docType, setDocType] = useState("");
  const [isAddRoleOpen, setIsAddRoleOpen] = useState(false);
  const [jobLeadDetails, setJobLeadDetails] = useState(null);
  const [importWarningModal, setImportWarningModal] = useState(false);

  const importJobId = watch("importJobId");
  const customerAccount = watch("customerAccount");
  const deliveryCoordinates = watch("deliveryAddressCoordinates");
  const [deliveryLat, deliveryLng] = deliveryCoordinates?.split(",");
  const { removeFileConfirmationTitle, removeConfirmationContent } =
    createJobCommonConstants;

  const handleOpenUploadModal = (docTypeSelected) => {
    const fileConfig = docConfig[docTypeSelected];
    if (fileConfig) {
      fileConfig.setCommitted(fileConfig.getFile());
    }
    setIsUploadModalOpen(true);
    setDocType(docTypeSelected);
  };
  const handleCloseUploadModal = () => {
    setIsUploadModalOpen(false);
    setDocType("");
  };
  const handleAddRoleModalOpen = () => setIsAddRoleOpen(true);
  const handleAddRoleModalClose = () => setIsAddRoleOpen(false);

  const retainDocumentAction = async (docData, docType) => {
    const documentData = docData;
    if (docType === DocTypes.PROJECT_INFORMATION_SHEET) {
      setProjectFile(documentData);
    }
    if (docType === DocTypes.TAX_EXEMPT_CERTIFICATE) {
      setTaxFile(documentData);
    }
  };

  const handleIsReceivedRadio = (value) => {
    if (
      value === ProjectInformationSheetState.NOT_RECEIVED &&
      projectFile?.docType === DocTypes.PROJECT_INFORMATION_SHEET
    ) {
      const projectDoc = {
        ...projectFile,
        docType: DocTypes.DEPRECATED_PROJECT_INFORMATION_SHEET,
        document: DocTypes.DEPRECATED_PROJECT_INFORMATION_SHEET,
      };
      showConfirmModal({
        docType: DocTypes.PROJECT_INFORMATION_SHEET,
        //Retain
        title: removeFileConfirmationTitle(DocTypes.PROJECT_INFORMATION_SHEET),
        content: removeConfirmationContent,
        onOk: () => {
          setIsReceived(value);
          retainDocumentAction(projectDoc, DocTypes.PROJECT_INFORMATION_SHEET);
        },
        //Remove
        onCancel: () => {
          setProjectFile(null);
          setIsReceived(value);
        },
      });
      return;
    } else {
      if (
        projectFile?.docType === DocTypes.DEPRECATED_PROJECT_INFORMATION_SHEET
      ) {
        const updatedProjectDoc = {
          ...projectFile,
          docType: DocTypes.PROJECT_INFORMATION_SHEET,
          document: DocTypes.PROJECT_INFORMATION_SHEET,
        };
        setProjectFile(updatedProjectDoc);
      }
      setIsReceived(value);
    }
  };

  const handleIsExemptRadio = (value) => {
    if (
      value === TaxExemptCertificateState.NOT_EXEMPT &&
      taxFile?.docType === DocTypes.TAX_EXEMPT_CERTIFICATE
    ) {
      const taxDoc = {
        ...taxFile,
        docType: DocTypes.DEPRECATED_TAX_EXEMPT_CERTIFICATE,
        document: DocTypes.DEPRECATED_TAX_EXEMPT_CERTIFICATE,
      };
      showConfirmModal({
        docType: DocTypes.TAX_EXEMPT_CERTIFICATE,
        title: removeFileConfirmationTitle(DocTypes.TAX_EXEMPT_CERTIFICATE),
        content: removeConfirmationContent,
        //Retain
        onOk: () => {
          setIsExempt(value);
          retainDocumentAction(taxDoc, DocTypes.TAX_EXEMPT_CERTIFICATE);
        },
        //Remove
        onCancel: () => {
          setTaxFile(null);
          setIsExempt(value);
        },
      });
      return;
    } else {
      if (taxFile?.docType === DocTypes.DEPRECATED_TAX_EXEMPT_CERTIFICATE) {
        const updatedTaxDoc = {
          ...taxFile,
          docType: DocTypes.TAX_EXEMPT_CERTIFICATE,
          document: DocTypes.TAX_EXEMPT_CERTIFICATE,
        };
        setTaxFile(updatedTaxDoc);
      }
      setIsExempt(value);
    }
  };

  const handleSelectedCustomer = (selectedCustomer: string) => {
    setSelectedCustomer(selectedCustomer);
  };

  const handleOpenImportWarningModal = () => setImportWarningModal(true);
  const handleCloseImportWarningModal = () => setImportWarningModal(false);

  const {
    FetchAllJobsMeta,
    FetchCustomerAccounts,
    FetchContacts,
    FetchSalesPerson,
    AddCustomer,
    AddContact,
    EditContact,
    GetLocationFromCoordinates,
    FetchLeadDetail,
  } = CreateJobServices();
  const { GetAccountTermsOptions, FetchContactRoles } =
    CustomerDatabaseService();
  const { mutateAsync: addCustomer, isPending: isCustomerAddPending } =
    AddCustomer();
  const { mutateAsync: addContact, isPending: isContactAddPending } =
    AddContact();
  const { mutateAsync: editContact, isPending: isContactEditPending } =
    EditContact();
  const { mutateAsync: fetchLeadDetail, isPending: fetchLeadDetailLoading } =
    FetchLeadDetail();

  const { data: paymentTermsOptions, mutateAsync: getPaymentTerms } =
    GetAccountTermsOptions({ isCrm: true });
  const { data: contactRoles } = FetchContactRoles({ isCrm: true });
  const contactRoleList = useMemo(() => {
    return contactRoles?.data?.map((item) => ({
      value: item?.id,
      label: item.roleName,
    }));
  }, [contactRoles]);
  const {
    data,
    isLoading: isCustomerAccountLoading,
    refetch: refetchCustomerAccounts,
  } = FetchCustomerAccounts();
  const {
    data: contactDetails,
    refetch: refetchContacts,
    isLoading: isContactLoading,
    isRefetching: isContactRefetching,
  } = FetchContacts(customerAccount);

  const { data: jobsMeta } = FetchAllJobsMeta();
  const { data: salesPersonData, isFetching: isSalesPersonLoading } =
    FetchSalesPerson();
  const [isContactEdit, setIsContactEdit] = useState<boolean>(false);
  const jobDropdownOptions = getJobDropdownOptions(jobsMeta?.jobs);
  const customerDropdownOptions = getDropdownOptions(data);
  const salesPersonDropdownOptions =
    getSalesPersonDropdownOptions(salesPersonData);

  const [projectFile, setProjectFile] = useState(uploadedFiles[0] ?? null);
  const handleProjectUpload = (file) => setProjectFile(file);

  const [taxFile, setTaxFile] = useState(uploadedFiles[1] ?? null);
  const handleTaxUpload = (file) => setTaxFile(file);
  const [isUploading, setIsUploading] = useState(false);
  const committedProjectFile = useRef(uploadedFiles[0] ?? null);
  const committedTaxFile = useRef(uploadedFiles[1] ?? null);

  const handleOk = async () => {
    try {
      const fileConfig = docConfig[docType];
      if (!fileConfig) return;

      const file = fileConfig.getFile();
      fileConfig.setCommitted(file);

      if (!file) {
        fileConfig.nullify();
      } else {
        setIsUploading(true);
        message.success(successMessage.fileSubmissionSuccess);
      }
      handleCloseUploadModal();
    } catch (error) {
      message.error(errorMessage.fileSubmmisionFailure);
    } finally {
      setIsUploading(false);
    }
  };

  const handleOnCancel = () => {
    if (docType === DocTypes.PROJECT_INFORMATION_SHEET) {
      setProjectFile(committedProjectFile.current);
      handleProjectFileUpload(committedProjectFile.current);
    }
    if (docType === DocTypes.TAX_EXEMPT_CERTIFICATE) {
      setTaxFile(committedTaxFile.current);
      handleTaxFileUpload(committedTaxFile.current);
    }

    handleCloseUploadModal();
    return;
  };

  const nullifyProjectUpload = () => {
    handleIsReceivedRadio("notReceived");
    setProjectFile(null);
  };

  const nullifyTaxUpload = () => {
    handleIsExemptRadio("notExempt");
    setTaxFile(null);
  };

  const handlet = () => {
    handleIsReceivedRadio("notReceived");
  };

  const docConfig = useMemo(
    () => ({
      [DocTypes.PROJECT_INFORMATION_SHEET]: {
        getFile: () => projectFile,
        setCommitted: (file) => (committedProjectFile.current = file),
        nullify: nullifyProjectUpload,
      },
      [DocTypes.TAX_EXEMPT_CERTIFICATE]: {
        getFile: () => taxFile,
        setCommitted: (file) => (committedTaxFile.current = file),
        nullify: nullifyTaxUpload,
      },
    }),
    [projectFile, taxFile],
  );

  const onChangeHandler =
    (fieldName: string) =>
    (event: React.ChangeEventHandler<HTMLInputElement>) => {
      setValue(fieldName, event);
      if (fieldName === fieldNames.CUSTOMER_FIELD) {
        setValue(fieldNames.CONTACT_FIELD, null);
      }
    };

  const getContactOptionItem = (item: any) => {
    return (
      <div className={styles.contactOption}>
        <div className={styles.textContainer}>
          <Tooltip
            title={`${item.firstName} ${item.lastName}\n ${!!item?.email ? item?.email : item?.phone}`}
            destroyTooltipOnHide
          >
            <span className={styles.mainText}>
              {item.firstName} {item.lastName}
            </span>
            <span className={styles.secondaryText}>
              {!!item?.email ? item?.email : item?.phone}
            </span>
          </Tooltip>
        </div>
        <div
          className={styles.editContactIcon}
          onClick={(e) => {
            e.stopPropagation();
            setIsContactEdit(true);
            setContactModalDefaultValue({
              id: item?.id,
              contactFirstName: item?.firstName,
              contactLastName: item?.lastName,
              contactEmail: item?.email,
              contactPhone: item?.phone,
              contactCompanyNotes: item?.notes,
              roleId: item?.roleId,
            });
            handleContactModalOpen();
          }}
        >
          <img src={contactEditIcon} alt={"click to edit"} />
        </div>
      </div>
    );
  };

  const contactDropdownOptions = useMemo(
    () =>
      getDropdownOptionsCustomLabel(contactDetails, (item) =>
        getContactOptionItem(item),
      ),
    [contactDetails],
  );

  const importAndReplaceJob = async () => {
    try {
      const data = await fetchLeadDetail(importJobId);

      setValue("customerAccount", data.companyId);
      setValue("deliveryAddress", data.dropoff);
      setValue(
        "deliveryAddressCoordinates",
        `${data.dropOffLatLng.lat}, ${data.dropOffLatLng.lng}`,
      );
      setValue("salesPerson", data.salesPersonId);
      setJobLeadDetails(data);

      handleEnableResetOrders();
      handleSelectedImportJobId(importJobId);
    } catch (error) {
      setValue("importJobId", selectedImportJobId);
      message.error("Failed to import job");
    }
  };

  const handleImportJobApply = async () => {
    if (selectedImportJobId) {
      handleOpenImportWarningModal();
      return;
    }
    importAndReplaceJob();
  };

  useEffect(() => {
    if (jobLeadDetails && contactDetails?.length > 0) {
      setValue("contactName", jobLeadDetails?.multipleContacts[0]?.id);
      setJobLeadDetails(null);
    }
  }, [contactDetails, jobLeadDetails]);

  useEffect(() => {
    refetchContacts();
  }, [selectedCustomer, customerAccount]);

  useEffect(() => {
    setValue("uploadedProjectFile", projectFile ?? null);
    handleProjectFileUpload(projectFile ?? null);
  }, [projectFile]);

  useEffect(() => {
    setValue("uploadedTaxFile", taxFile ?? null);
    handleTaxFileUpload(taxFile ?? null);
  }, [taxFile]);

  useEffect(() => {
    if (
      !!uploadedFiles[0] &&
      uploadedFiles[0]?.docType === DocTypes.PROJECT_INFORMATION_SHEET
    ) {
      handleIsReceivedRadio("received");
    } else {
      nullifyProjectUpload();
    }
  }, [uploadedFiles[0]]);

  useEffect(() => {
    if (
      !!uploadedFiles[1] &&
      uploadedFiles[1]?.docType === DocTypes.TAX_EXEMPT_CERTIFICATE
    ) {
      handleIsExemptRadio("exempt");
    } else {
      nullifyTaxUpload();
    }
  }, [uploadedFiles[1]]);

  useEffect(() => {
    if (!!isReceived && !!isExempt) {
      fileUploadHandler({
        projectInformation: isReceived,
        taxExempt: isExempt,
      });
    }
  }, [isReceived, isExempt]);

  useEffect(() => {
    if (jobDetails) {
      setIsReceived(jobDetails?.projectInformationSheet || "");
      setIsExempt(jobDetails?.taxExempt || "");
      const projectFileDoc = jobDetails?.documentDetails?.find(
        (doc) => doc.docType === DocTypes.PROJECT_INFORMATION_SHEET,
      );
      const taxFileDoc = jobDetails?.documentDetails?.find(
        (doc) => doc.docType === DocTypes.TAX_EXEMPT_CERTIFICATE,
      );
      handleProjectUpload(projectFileDoc ?? null);
      handleTaxUpload(taxFileDoc ?? null);
    }
  }, [jobDetails]);
  useEffect(() => {
    if (
      location.pathname.includes("/app/add-trucking-material") &&
      leadId === ""
    ) {
      nullifyProjectUpload();
      nullifyTaxUpload();
    }
    refetchCustomerAccounts();
  }, [location.pathname, leadId]);

  const [isCustomerUploadModalOpen, setIsCustomerUploadModalOpen] =
    useState(false);
  const [isContactUploadModalOpen, setIsContactUploadModalOpen] =
    useState(false);

  const [isContactSaveModalOpen, setIsContactSaveModalOpen] = useState(false);
  //Modal handlers
  const handleCustomerModalOpen = () => setIsCustomerUploadModalOpen(true);
  const handleContactModalOpen = () => setIsContactSaveModalOpen(true);
  const customerAddModalInputFields = addCustomerModalFields({
    paymentTerms: paymentTermsOptions,
  });
  const contactAddModalInputFields = addContactModalFields({
    contactRoles: contactRoleList,
    handleOpenAddRoleModal: handleAddRoleModalOpen,
  });

  const jobLeadsFields = getJobLeadsFields({
    jobDropdownOptions,
    customerDropdownOptions: customerDropdownOptions,
    contactDetails: contactDropdownOptions,
    salesPersonDropdownOptions: salesPersonDropdownOptions,
    handleSelectedCustomer: handleSelectedCustomer,
    handleIsExemptRadio,
    handleIsReceivedRadio,
    isReceivedValue: isReceived,
    isExemptValue: isExempt,
    handleCustomerModalOpen,
    handleContactModalOpen,
    editable,
    importJobId,
  });

  const [newContacts, setNewContacts] = useState([]);
  const [newCustomer, setNewCustomer] = useState([]);

  const handleNewContactDelete = (id: string) => {
    setNewContacts(newContacts?.filter((contact) => contact?.id !== id));
  };

  const [contactModalDefaultValue, setContactModalDefaultValue] = useState({});

  useEffect(() => {
    getPaymentTerms();
  }, []);

  const { data: locationData } = GetLocationFromCoordinates({
    lat: deliveryLat?.trim(),
    lon: deliveryLng?.trim(),
  });

  return (
    <div>
      <Loading
        enableLoading={
          !!jobLeadDetails ||
          isCustomerAccountLoading ||
          isSalesPersonLoading ||
          isContactLoading ||
          fetchLeadDetailLoading
        }
      />
      <Modal
        visible={importWarningModal}
        onCancel={handleCloseImportWarningModal}
        title="Confirm Replace"
        okText="Continue"
        onOk={() => {
          handleCloseImportWarningModal();
          importAndReplaceJob();
        }}
      >
        <p style={{ fontSize: "1rem" }}>
          Importing a different job will replace all previously imported job,
          material, and truck details. Any unsaved imported changes will be
          lost. Do you want to continue?
        </p>
      </Modal>
      <Modal
        okButtonProps={{
          disabled: isUploading,
        }}
        visible={isUploadModalOpen}
        destroyOnClose
        onCancel={handleOnCancel}
        width={UploadModalConst.MODAL_WIDTH}
        title={UploadModalConst.MODAL_TITLE}
        okText={UploadModalConst.UPLOAD_BTN_TEXT}
        className={styles.UploadModal}
        onOk={handleOk}
      >
        <ConditionalRender
          visible={docType === DocTypes.PROJECT_INFORMATION_SHEET}
        >
          <ProjectInformationSheetProofUpload
            onFilesUploaded={handleProjectUpload}
            docType={docType}
            filesUploaded={projectFile === null ? [] : [projectFile]}
            maxFileSize={10}
            key={docType}
            leadId={jobDetails?.id}
            allowedFileTypes={[
              FileTypes.PDF,
              FileTypes.DOC,
              FileTypes.DOCX,
              FileTypes.XLS,
              FileTypes.XLSX,
              FileTypes.CSV,
              FileTypes.JPEG,
              FileTypes.JPG,
              FileTypes.PNG,
            ]}
          />
        </ConditionalRender>
        <ConditionalRender
          visible={docType === DocTypes.TAX_EXEMPT_CERTIFICATE}
        >
          <ProjectInformationSheetProofUpload
            onFilesUploaded={handleTaxUpload}
            docType={docType}
            filesUploaded={taxFile === null ? [] : [taxFile]}
            maxFileSize={10}
            key={docType}
            leadId={jobDetails?.id}
            allowedFileTypes={[
              FileTypes.PDF,
              FileTypes.DOC,
              FileTypes.DOCX,
              FileTypes.XLS,
              FileTypes.XLSX,
              FileTypes.CSV,
              FileTypes.JPEG,
              FileTypes.JPG,
              FileTypes.PNG,
            ]}
          />
        </ConditionalRender>
      </Modal>
      <Form validationSchema={addRoleValidation}>
        {() => (
          <AddRoleModal
            isOpen={isAddRoleOpen}
            handleClose={handleAddRoleModalClose}
          />
        )}
      </Form>
      <Form
        defaultValues={contactModalDefaultValue}
        validationSchema={addContactFormValidation}
        key={JSON.stringify(contactModalDefaultValue)}
      >
        {({ setValue, getValues, control: { handleSubmit, _reset } }) => {
          const handleClose = () => {
            setIsContactEdit(false);
            setIsContactSaveModalOpen(false);
            setIsContactUploadModalOpen(false);
            setContactModalDefaultValue({});
            _reset();
          };
          const handleSuccessState = (isEdit: boolean) => {
            if (isEdit) setIsContactEdit(false);
            setIsContactSaveModalOpen(false);
            refetchContacts();
            setNewContacts([]);
            _reset();
          };
          const handleAddContact = async () => {
            const roleIdValue = getValues(addContactFieldNames.roleId);
            const contactParams = {
              id: contactModalDefaultValue?.id ?? uuidv4(),
              contact_name: `${getValues(
                addContactFieldNames.contactFirstName,
              )} ${getValues(addContactFieldNames.contactLastName)}`,
              contact_number: getValues(addContactFieldNames.contactPhone),
              contact_email: getValues(addContactFieldNames.contactEmail),
              firstName: getValues(addContactFieldNames.contactFirstName),
              lastName: getValues(addContactFieldNames.contactLastName),
              phone: getValues(addContactFieldNames.contactPhone),
              email: getValues(addContactFieldNames.contactEmail),
              notes: getValues(addContactFieldNames.contactNotes),
              roleId: roleIdValue,
              contactRole: contactRoles?.data?.filter(
                (item) => item?.id === roleIdValue,
              )?.[0]?.roleName,
            };
            if (isContactSaveModalOpen) {
              if (isContactEdit) {
                await editContact(
                  { ...contactParams, companyId: customerAccount },
                  {
                    onSuccess: () => {
                      message.success(contactEditMessages.success);
                      handleSuccessState(true);
                    },
                    onError: (error) => {
                      message.error(
                        error?.response?.data?.message?.trim() ??
                          contactEditMessages.failure,
                      );
                    },
                  },
                );
              } else {
                await addContact(
                  { ...contactParams, companyId: customerAccount },
                  {
                    onSuccess: () => {
                      message.success(contactAddMessages.success);
                      handleSuccessState(false);
                    },
                    onError: (error) => {
                      message.error(
                        error?.response?.data?.message?.trim() ??
                          contactAddMessages.failure,
                      );
                    },
                  },
                );
              }
            } else {
              const updatedContactList = newContacts.filter(
                (contact) => contact?.id !== contactModalDefaultValue?.id,
              );
              setNewContacts([...updatedContactList, contactParams]);
              setIsContactUploadModalOpen(false);
            }
            setContactModalDefaultValue({});
            _reset();
          };
          return (
            <Modal
              zIndex={contactModalFields.zIndex}
              title={
                isContactEdit
                  ? contactModalFields.editTitle
                  : contactModalFields.addTitle
              }
              width={contactModalFields.width}
              visible={isContactUploadModalOpen || isContactSaveModalOpen}
              onCancel={handleClose}
              onOk={handleSubmit(handleAddContact)}
              okButtonProps={{
                loading: isContactAddPending || isContactEditPending,
              }}
            >
              <div className={styles.addNewContactContainer}>
                <div className={styles.inputFields}>
                  {contactAddModalInputFields?.map((field) => {
                    return (
                      <InputField
                        name={field.name}
                        label={field.label}
                        placeholder={field.placeHolder}
                        type={field.type}
                        requiredField={field.required}
                        options={field.options}
                        {...(field.type === InputfieldTypes.SELECT_CUSTOM_FIELD
                          ? {
                              dropdownSelectRender: (
                                <>
                                  <TNButton
                                    text={field.customButtonLabel}
                                    type={ButtonType.PRIMARY}
                                    size={ButtonSize.LARGE}
                                    onClick={field.handleModalOpen}
                                    customStyles={customStylingSelectField}
                                    shape={ButtonShape.DEFAULT}
                                  />
                                </>
                              ),
                              allowClear: true,
                              onSelect: (val) => {
                                setValue(field.name, val);
                              },
                            }
                          : {
                              onChange: (e) => {
                                setValue(
                                  field.name,
                                  field.name ===
                                    addContactFieldNames.contactPhone
                                    ? formatPhoneNumber(e)
                                    : e.target.value,
                                );
                              },
                            })}
                      />
                    );
                  })}
                </div>
                <div className={styles.notesContainer}>
                  <InputField
                    name={addCustomerContactNotesFields.contactName}
                    label={addCustomerContactNotesFields.label}
                    placeholder={addCustomerContactNotesFields.placeHolder}
                    type={addCustomerContactNotesFields.type}
                    requiredField={addCustomerContactNotesFields.required}
                  />
                </div>
              </div>
            </Modal>
          );
        }}
      </Form>
      <Form validationSchema={addCustomerFormValidation}>
        {({
          watch,
          setValue,
          getValues,
          control: { handleSubmit, _reset },
        }) => {
          const handleClose = () => {
            setIsCustomerUploadModalOpen(false);
            setNewContacts([]);
            _reset();
          };
          const isCustomTerms =
            watch(addCustomerFieldNames.companyAccountTerms) === CUSTOM_INPUT;
          const handleSave = async () => {
            const customerParams = {
              company: getValues(addCustomerFieldNames.companyName),
              companyName: getValues(addCustomerFieldNames.companyName),
              accountTerms: isCustomTerms
                ? getValues(addCustomerFieldNames.customTerms)
                : getValues(addCustomerFieldNames.companyAccountTerms),
              email: getValues(addCustomerFieldNames.companyMail),
              phone: getValues(addCustomerFieldNames.companyPhone),
              address: getValues(addCustomerFieldNames.companyAddress),
              notes: getValues(addCustomerFieldNames.companyNotes),
              isOwnerOperator: false,
              multiContact: true,
              leadType: [
                {
                  id: "1",
                  value: "Material Sales",
                },
              ],
              activeJobs: 0,
              accountStatus: "Inactive",
              contactInfo: newContacts,
            };
            setNewCustomer(customerParams);
            await addCustomer(customerParams, {
              onSuccess: () => {
                message.success(customerAddMessages.success);
                setIsCustomerUploadModalOpen(false);
                refetchCustomerAccounts();
                setNewContacts([]);
                _reset();
              },
              onError: (error) => {
                message.error(
                  error?.response?.data?.message?.trim() ??
                    customerAddMessages.failure,
                );
              },
            });
          };
          return (
            <Modal
              zIndex={customerModalFields.zIndex}
              title={customerModalFields.name}
              width={customerModalFields.width}
              visible={isCustomerUploadModalOpen}
              onCancel={handleClose}
              onOk={handleSubmit(handleSave)}
              okButtonProps={{
                loading: isCustomerAddPending,
              }}
            >
              <div className={styles.addNewCustomerContainer}>
                <div className={styles.gridFields}>
                  {customerAddModalInputFields?.map((field) => {
                    return (
                      <>
                        <ConditionalRender
                          visible={field.type === InputfieldTypes.ONCHANGE_TEXT}
                        >
                          <InputField
                            name={field.name}
                            label={field.label}
                            type={field.type}
                            requiredField={field.required}
                            placeholder={field.placeHolder}
                            onChange={(e) =>
                              setValue(
                                field.name,
                                field.name ===
                                  addCustomerFieldNames.companyPhone
                                  ? formatPhoneNumber(e)
                                  : e.target.value,
                              )
                            }
                          />
                        </ConditionalRender>
                        <ConditionalRender
                          visible={field.type === InputfieldTypes.SELECT}
                        >
                          <InputField
                            name={field.name}
                            label={field.label}
                            type={field.type}
                            requiredField={field.required}
                            placeholder={field.placeHolder}
                            customSelect={false}
                            customSelectInputError={false}
                            customLarge={false}
                            options={field.options}
                          />
                        </ConditionalRender>
                        <ConditionalRender
                          visible={
                            field.type === InputfieldTypes.TEXT && isCustomTerms
                          }
                        >
                          <InputField
                            name={field.name}
                            label={field.label}
                            type={field.type}
                            placeholder={field.placeHolder}
                            formattedNumberType={field.formattedNumberType}
                            prefix={field.prefix}
                            large={true}
                          />
                        </ConditionalRender>
                        <ConditionalRender
                          visible={field.type === InputfieldTypes.GOOGLE}
                        >
                          <TNGoogleAddressSuggestions
                            name={field.name}
                            label={field.label}
                            requiredField={field.required}
                            placeholder={field.placeHolder}
                            isCompanyAddress={field.isCompanyAddress ?? true}
                          />
                        </ConditionalRender>
                      </>
                    );
                  })}
                </div>
                <div className={styles.notesContainer}>
                  <InputField
                    name={addCustomerContactNotesFields.customerName}
                    label={addCustomerContactNotesFields.label}
                    placeholder={addCustomerContactNotesFields.placeHolder}
                    type={addCustomerContactNotesFields.type}
                    requiredField={addCustomerContactNotesFields.required}
                  />
                </div>
                <div className={styles.newContactsListingContainer}>
                  {newContacts?.map((contact) => (
                    <div className={styles.newContactBlock}>
                      <div className={styles.newContactName}>
                        {contact?.contact_name}
                      </div>
                      <Popover
                        trigger={PopoverTrigger.HOVER}
                        content={
                          <div className={styles.editListingContainer}>
                            <div
                              onClick={() => {
                                setContactModalDefaultValue({
                                  id: contact?.id,
                                  contactFirstName: contact?.firstName,
                                  contactLastName: contact?.lastName,
                                  contactEmail: contact?.email,
                                  contactPhone: contact?.phone,
                                  contactCompanyNotes: contact?.notes,
                                  roleId: contact?.roleId,
                                });
                                setIsContactUploadModalOpen(true);
                              }}
                            >
                              <img src={editIcon} /> Edit
                            </div>
                            <div
                              onClick={() =>
                                handleNewContactDelete(contact?.id)
                              }
                            >
                              <img src={deleteIcon} /> Delete
                            </div>
                          </div>
                        }
                        zIndex={10002}
                        placement={PlacementPositions.RIGHT_TOP}
                      >
                        <div className={styles.newContactEditEllips}>
                          <img src={editEllips} />
                        </div>
                      </Popover>
                    </div>
                  ))}
                </div>
                <div className={styles.addContactButton}>
                  <TNButton
                    name={addContactButtonFields.name}
                    text={addContactButtonFields.label}
                    type={addContactButtonFields.type}
                    shape={addContactButtonFields.shape}
                    onClick={() => setIsContactUploadModalOpen(true)}
                  />
                </div>
              </div>
            </Modal>
          );
        }}
      </Form>
      <div className={styles.FieldsContainer}>
        {jobLeadsFields?.map((field) => {
          return (
            <>
              <ConditionalRender visible={field.width === "1/3"}>
                <ConditionalRender
                  visible={field.type === InputfieldTypes.TEXT}
                >
                  <div
                    className={clsx(styles.TopRowContainer, {
                      [styles.induceSpace]: field.induceSpace,
                    })}
                  >
                    <InputField
                      className={styles.TextFieldContainer}
                      name={field.name}
                      label={field.label}
                      type={field.type}
                      placeholder={field.placeholder}
                      requiredField={field.required}
                      addonAfter={field.addOnAfter}
                      maxTextLength={field.maxLength}
                      {...(field.name === "deliveryAddressCoordinates"
                        ? {
                            onBlur: () => {
                              if (locationData) {
                                setValue(
                                  "deliveryAddress",
                                  locationData?.data?.formattedAddress,
                                );
                                clearErrors("deliveryAddress");
                              }
                            },
                          }
                        : {})}
                    />
                  </div>
                </ConditionalRender>
                <ConditionalRender
                  visible={field.type === InputfieldTypes.SELECT}
                >
                  <div
                    className={clsx(styles.TopRowContainerSelect, {
                      [styles.induceSpace]: field.induceSpace,
                    })}
                  >
                    <InputField
                      className={styles.SelectInputField}
                      name={field.name}
                      label={field.label}
                      customSelect={false}
                      placeholder={field.placeholder}
                      type={field.type}
                      requiredField={field.required}
                      options={field.options}
                      onSelect={field.handleOnSelect}
                      onChange={onChangeHandler(field.name)}
                      showSearch={field?.showSearch}
                      optionFilterProp="children"
                    />
                  </div>
                </ConditionalRender>
                <ConditionalRender
                  visible={
                    field.type === InputfieldTypes.SELECT_CUSTOM_FIELD &&
                    (field?.visible ?? true)
                  }
                >
                  <div
                    className={clsx(styles.TopRowContainerSelect, {
                      [styles.induceSpace]: field.induceSpace,
                    })}
                  >
                    <InputField
                      name={field.name}
                      placeholder={field.placeholder}
                      label={field.label}
                      requiredField={field.required}
                      type={field.type}
                      options={field.options}
                      onSelect={field.handleOnSelect}
                      onChange={onChangeHandler(field.name)}
                      {...(field.name === "customerAccount" ||
                      (field.name === "contactName" && customerAccount)
                        ? {
                            dropdownSelectRender: (
                              <>
                                <TNButton
                                  text={field.customButtonLabel}
                                  type={ButtonType.PRIMARY}
                                  size={ButtonSize.LARGE}
                                  onClick={field.handleModalOpen}
                                  customStyles={customStylingSelectField}
                                  shape={ButtonShape.DEFAULT}
                                />
                              </>
                            ),
                          }
                        : {})}
                    />
                  </div>

                  <ConditionalRender visible={field.name === "importJobId"}>
                    <div className={styles.importJobButtonContainer}>
                      <TNButton
                        disabled={field?.disabled}
                        type={ButtonType.PRIMARY}
                        text="Apply"
                        shape={ButtonShape.DEFAULT}
                        onClick={handleImportJobApply}
                      />
                    </div>
                  </ConditionalRender>
                </ConditionalRender>
                <ConditionalRender
                  visible={field.type === InputfieldTypes.GOOGLE}
                >
                  <div className={styles.TopContainerSelect}>
                    <TNGoogleAddressSuggestions
                      name={field.name}
                      label={field.label}
                      requiredField={field.required}
                      isAccountInformation
                      placeholder={field.placeholder}
                      suffixContent={field.suffixContent}
                      isDeliveryAddress={field.isDeliveryAddress}
                      isJobLead={true}
                    />
                  </div>
                </ConditionalRender>
              </ConditionalRender>
              <ConditionalRender visible={field.width === "2/3"}>
                <ConditionalRender
                  visible={field.type === InputfieldTypes.TEXT}
                >
                  <div className={styles.MiddleRowContainer}>
                    <InputField
                      name={field.name}
                      placeholder={field.placeholder}
                      label={field.label}
                      type={field.type}
                      requiredField={field.required}
                    />
                  </div>
                </ConditionalRender>
              </ConditionalRender>
              <ConditionalRender visible={field.width === "full"}>
                <ConditionalRender
                  visible={field.type === InputfieldTypes.TEXT_AREA}
                >
                  <div className={styles.LastRowContainer}>
                    <InputField
                      name={field.name}
                      placeholder={field.placeholder}
                      label={field.label}
                      type={field.type}
                      requiredField={field.required}
                      maxLength={field.limit}
                    />
                  </div>
                </ConditionalRender>
                <ConditionalRender
                  visible={
                    field.type === InputfieldTypes.LABEL &&
                    (field?.visible ?? true)
                  }
                >
                  <div className={styles.title}>{field.label}</div>
                </ConditionalRender>
              </ConditionalRender>
              <ConditionalRender
                visible={field.width === "1/4" && field.withUpload === true}
              >
                <ConditionalRender visible={field.type === "radio"}>
                  <div className={styles.RadioButtonsContainer}>
                    <div className={styles.uploadContainer}>
                      <div className={styles.RadioButtonContainer}>
                        <Label label={field.label} required />
                        <RadioComponent
                          name={field.name}
                          options={field.options}
                          value={field.value}
                          onChange={field.handleOnChange} //To be updated in next PRs
                        />
                      </div>
                      {/* <Upload {...props}> */}
                      <ConditionalRender
                        visible={
                          field.name === "projectInformationSheet" &&
                          isReceived === "received"
                        }
                      >
                        <TNButton
                          type={ButtonType.PRIMARY}
                          text="Upload File"
                          shape={ButtonShape.DEFAULT}
                          onClick={() =>
                            handleOpenUploadModal(
                              DocTypes.PROJECT_INFORMATION_SHEET,
                            )
                          }
                        />
                      </ConditionalRender>
                      <ConditionalRender
                        visible={
                          field.name === "taxExemptStatus" &&
                          isExempt === "exempt"
                        }
                      >
                        <TNButton
                          type={ButtonType.PRIMARY}
                          text="Upload File"
                          shape={ButtonShape.DEFAULT}
                          onClick={() =>
                            handleOpenUploadModal(
                              DocTypes.TAX_EXEMPT_CERTIFICATE,
                            )
                          }
                        />
                      </ConditionalRender>
                      {/* </Upload> */}
                    </div>
                  </div>
                </ConditionalRender>
              </ConditionalRender>
              <div className={styles.UploadWrapper}>
                <InputField
                  name="uploadedProjectFile"
                  type={InputfieldTypes.TEXT}
                />
              </div>
              <div className={styles.UploadWrapper}>
                <InputField
                  name="uploadedTaxFile"
                  type={InputfieldTypes.TEXT}
                />
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default JobLead;
